import { InputFieldV5 } from "components/form";

const INPUT_FIELDS = [
  {
    name: "newOwnerEmail",
    group: "transferPet",
    type: "email",
    icon: "fa fa-envelope",
    className: "input ",
    component: InputFieldV5,
    required: false,
  },
];

export { INPUT_FIELDS };
